module.exports = __webpack_public_path__ + "static/media/wind-blow.5f87f529.png";